'use client';

import type { ReactNode } from 'react';
import { useRef } from 'react';

import { useOutsideClick } from '@repo/sds/hooks/use-outside-click';

export interface SDSClickAwayProps {
  children: ReactNode;
  onClickAway: () => void;
  className?: string;
  dataTestId?: string;
}

export function SDSClickAway({ children, onClickAway, className, dataTestId }: SDSClickAwayProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useOutsideClick([containerRef], onClickAway);

  return (
    <div ref={containerRef} className={className} data-testid={dataTestId}>
      {children}
    </div>
  );
}
